(() => {
  let requestSequence = 0;
  let controller = null;
  const root = window.Shopify?.routes?.root || '/';
  const formatter = new Intl.NumberFormat('en-IN', {style:'currency',currency:'INR',maximumFractionDigits:2});
  const panels = () => document.querySelectorAll('[data-ss-cart]');
  const invalidate = () => {
    requestSequence++;
    controller?.abort();
    controller = null;
  };
  function renderPanel(panel, state) {
    panel.hidden = !state.count;
    const thresholds = JSON.parse(panel.dataset.thresholds);
    const labels = JSON.parse(panel.dataset.labels);
    const total = Math.max(0, Number(state.total) || 0);
    const eligible = state.currency === 'INR';
    const eligibleAmount = panel.querySelector('[data-ss-eligible-money]');
    if(eligibleAmount && eligible) eligibleAmount.textContent = formatter.format(total/100);
    let level = -1;
    thresholds.forEach((threshold,index) => {if(total >= threshold) level = index;});
    const next = level + 1;
    panel.querySelector('[data-ss-level]').textContent = eligible && level >= 0 ? panel.dataset.level.replace('__REWARD__',labels[level]) : '';
    panel.querySelector('[data-ss-next]').textContent = !eligible ? panel.dataset.currency : !state.count ? panel.dataset.empty : next < thresholds.length ? panel.dataset.add.replace('__AMOUNT__',formatter.format(Math.max(0,thresholds[next]-total)/100)).replace('__REWARD__',labels[next]) : panel.dataset.max;
    panel.querySelector('[data-ss-progress]').value = eligible ? Math.min(100,total / Math.max(1,thresholds[thresholds.length-1]) * 100) : 0;
    const choice = panel.querySelector('[data-ss-choice]');
    if(choice) choice.hidden = !eligible || level < 1;
    const select = panel.querySelector('[data-ss-select]');
    if(select && ['surprise','resin','candle','pipe'].includes(state.world)) select.value = state.world;
  }
  function renderSections(sections) {
    for(const html of Object.values(sections || {})) {
      if(typeof html !== 'string') continue;
      const source = new DOMParser().parseFromString(html,'text/html').querySelector('[data-ss-cart]');
      if(!source) continue;
      const state = {total:source.dataset.cartTotal,count:Number(source.dataset.cartCount),currency:source.dataset.cartCurrency,world:source.dataset.cartWorld};
      panels().forEach(panel => {
        Object.assign(panel.dataset,{cartTotal:state.total,cartCount:String(state.count),cartCurrency:state.currency,cartWorld:state.world});
        renderPanel(panel,state);
      });
      return true;
    }
    return false;
  }
  function renderSection(panel) {
    renderPanel(panel,{total:panel.dataset.cartTotal,count:Number(panel.dataset.cartCount),currency:panel.dataset.cartCurrency,world:panel.dataset.cartWorld});
  }
  async function refresh() {
    if(!panels().length) return;
    invalidate();
    const sequence = requestSequence;
    const activeController = new AbortController();
    controller = activeController;
    try {
      const response = await fetch(root+'cart?sections=cart-drawer',{headers:{Accept:'application/json'},signal:activeController.signal});
      if(!response.ok) return;
      const sections = await response.json();
      if(sequence === requestSequence && !renderSections(sections)) panels().forEach(panel => {panel.hidden = true;});
    } catch {}
    finally {if(controller === activeController) controller = null;}
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ss-save]');
    if(!button) return;
    const panel = button.closest('[data-ss-cart]');
    const value = panel.querySelector('[data-ss-select]').value;
    const status = panel.querySelector('[data-ss-status]');
    button.disabled = true;
    status.textContent = panel.dataset.saving;
    invalidate();
    const sequence = requestSequence;
    try {
      const response = await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{'Secret Studio world':value},sections:['cart-drawer']})});
      if(!response.ok) throw new Error('save');
      const cart = await response.json();
      if(sequence === requestSequence) renderSections(cart.sections);
      status.textContent = panel.dataset.saved;
    } catch {status.textContent = panel.dataset.error;}
    finally {button.disabled = false;}
  });
  const observer = new MutationObserver(records => {
    const added = new Set();
    records.forEach(record => record.addedNodes.forEach(node => {
      if(node.nodeType !== 1) return;
      if(node.matches('[data-ss-cart]')) added.add(node);
      node.querySelectorAll('[data-ss-cart]').forEach(panel => added.add(panel));
    }));
    if(!added.size) return;
    invalidate();
    added.forEach(panel => {if(panel.isConnected) renderSection(panel);});
  });
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',() => {invalidate();panels().forEach(renderSection);});
  document.addEventListener('visibilitychange',() => {if(!document.hidden) refresh();});
  if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate,event => {
      const cart = event?.cartData;
      invalidate();
      if(cart?.item_count === 0) panels().forEach(panel => {panel.hidden = true;});
      else if(!renderSections(cart?.sections)) refresh();
    });
  }
  panels().forEach(renderSection);
})();
